import routes from "./aapi1Routes";
import raw from "./rawClients/rawAapi1Client";
export default {
  NAME: "aapi1Client",
  contracts: {
    getAll: orgId => raw.get(routes.contracts.all(orgId)),
  },
  orgUsers: {
    add: (orgId, emails, plan) =>
      raw.post(routes.orgUsers.all(orgId), { emails, plan }),
    updateLicense: (orgId, userId, plan) =>
      raw.put(routes.orgUsers.one(orgId, userId), {
        plan,
        // no reason to make this call if purchase_approved is false, but defaults to false on backend
        // https://github.com/plangrid/admin-api/blob/test/app/controllers/organization_user_handler.py#L163
        purchase_approved: true,
      }),
    remove: (orgId, userId) => raw.delete(routes.orgUsers.one(orgId, userId)),
    resendInvitation: (orgId, userId) =>
      raw.post(routes.orgUsers.invitationEmail(orgId, userId), {}),
  },
  orgAdmins: {
    add: (orgId, emails) =>
      raw.post(routes.orgAdmins.invites(orgId), { emails }),
    remove: (orgId, userId) => raw.delete(routes.orgAdmins.one(orgId, userId)),
    resendInvitation: (orgId, userId) =>
      raw.post(routes.orgAdmins.invitationEmail(orgId, userId), {}),
  },
  orgAdminOrgs: {
    getAll: userId => raw.get(routes.orgAdminOrgs.all(userId)),
  },
  licenses: {
    add: (orgId, quantities, billing_code) =>
      raw.post(routes.licenses.all(orgId), {
        ...quantities,
        billing_code,
      }),
    getAll: (orgId, include_inactive = false) =>
      raw.get(
        `${routes.licenses.all(
          orgId
        )}?shim_guest=false&include_inactive=${include_inactive}`
      ),
    upgrade: (orgId, licenseId, fromPlanId, toPlanId, billing_code) =>
      raw.put(routes.licenses.all(orgId), {
        billing_code,
        [`${fromPlanId}_to_${toPlanId}`]: [licenseId],
      }),
  },
};
